module.exports = __webpack_public_path__ + "static/img/logo-speedo.4246492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-speedo.png
// module id = o++c
// module chunks = 0